export const questions = [
    { 
        q: "Explain what is Javascript?", 
        a: `JavaScript is a high-level, 
        dynamic, untyped, and interpreted programming language. 
        It is widely used for creating interactive effects within web browsers`,
        code:  `Example:
// Adding two numbers in JavaScript
let a = 5;
let b = 10;
let sum = a + b;
console.log(sum); // Output: 15
            `
    },
    { 
        q: "Is Javascript single threaded or multithreaded? Explain in detail.", 
        a: `JavaScript is single-threaded, which means 
        it executes code in a single sequence, one operation at a time. 
        This model is based on the event loop and is non-blocking.`,
         code:   `Example:
           
// Single-threaded execution
console.log('First Task'); 
setTimeout(() => console.log('Second Task'), 1000); 
console.log('Third Task');

// Output:
// First Task
// Third Task
// Second Task (after 1 second)
            `
    },
    { 
        q: "How can I add Javascript in my HTML code, give me 2 possible ways.", 
        a: `You can add JavaScript in two ways:`,
            code:`1. Inline JavaScript:
           
&lt;button onclick="alert('Hello World!')"&gt;Click Me&lt;/button&gt;
            
            2. External JavaScript file:
           
&lt;script src="myscript.js"&gt;&lt;/script&gt;
           `
    },
    { 
        q: "Can I add a script tag in the head element?", 
        code: `Yes, you can add a &lt;script&gt; 
        tag in the &lt;head&gt; element. However, 
        if the script is not deferred or asynchronous, 
        it will block the HTML parsing until the script is loaded and executed.` 
    },
    { 
        q: "Does adding script tag in head element cause any problem?", 
        code: `Yes, it can cause problems. If a script in the &lt;head&gt; is not deferred or asynchronous, it can block the rendering of the HTML page, which may lead to a poor user experience.` 
    },
    { 
        q: "What are async and defer attributes?", 
        a: `The async and defer attributes are used in &lt;script&gt; 
        tags to control the loading and execution of external scripts.
            - async: The script is executed asynchronously, as soon as it is available.
            - defer: The script is executed after the HTML is parsed.`,
        code: `Example:
           
&lt;script src="async-script.js" async&gt;&lt;/script&gt;
&lt;script src="defer-script.js" defer&gt;&lt;/script&gt;
           ` 
    },
    
    // Add more questions and answers here
    {
        q: "Explain data types in JavaScript?",
        a: `JavaScript has several data types: 
            1. Primitive Types: Number, String, 
            Boolean, Undefined, Null, Symbol, BigInt
            2. Non-Primitive Types: Object (including Arrays, Functions, Dates, etc.)`,
            
        code: `Example:
           
let num = 42; // Number
let str = "Hello, World!"; // String
let isTrue = true; // Boolean
let obj = { name: "John", age: 30 }; // Object
let arr = [1, 2, 3]; // Array
let func = function() { return 'Hello'; }; // Function
           `
    },
    {
        q: "What is hoisting? Give examples.",
        a: `Hoisting is a JavaScript behavior 
        where variable and function declarations are moved 
        to the top of their scope during compilation. 
        However, only declarations are hoisted, not initializations.`,  
       code: `Example:
           
console.log(x); // undefined (due to hoisting)
var x = 5;

foo(); // Works fine because function declarations are hoisted
function foo() {
  console.log('Hello from foo!');
}
           `
    },
    {
        q: "What is closure? Give examples.",
        a: `A closure is a function that remembers 
        its lexical scope even when the function is executed outside that scope.`,
        code: `Example:
           
function outer() {
    let count = 0;
    return function inner() {
        count++;
        console.log(count);
    };
}

const counter = outer();
counter(); // Output: 1
counter(); // Output: 2
           `
    },
    {
        q: "What is stale closure? Give examples.",
        a: `A stale closure occurs when the inner 
        function remembers a variable that has changed in the outer function,
         but the value is "stale" or outdated in the closure.`,
        code: `Example:
           
function createCounter() {
    let count = 0;
    setTimeout(function() {
        console.log(count); // Stale closure: count is 0
    }, 1000);
    count = 5;
}

createCounter(); // Output: 0 (stale closure)
           `
    },
    {
        q: "Explain currying, its use case, and its benefits.",
        a: `Currying is a technique where 
        a function that takes multiple arguments is transformed 
        into a series of functions that each take a single argument.
            
            Use case: Useful when you want to create a function that can be partially applied.
            
            Benefits: It can help reduce redundancy and make the code more reusable.`,
            
        code: `Example:
           
function multiply(a) {
    return function(b) {
        return a * b;
    };
}

const multiplyBy2 = multiply(2);
console.log(multiplyBy2(3)); // Output: 6
           `
    },
    {
        q: "What is an IIFE?",
        a: `An IIFE (Immediately Invoked Function Expression) 
        is a function that is defined and executed immediately after its declaration.
         It’s often used to create a new scope to avoid polluting the global namespace.`,
            
            code: `Example:
           
(function() {
    console.log('I am an IIFE!');
})(); // Output: I am an IIFE!
           `
    },
    {
        q: "Give 4 ways to create an IIFE.",
        code: `You can create an IIFE in several ways:
            1. Using parentheses around the function expression
            2. Using the function keyword followed by parentheses
            3. Using the arrow function syntax
            4. Using an anonymous function
            
           Examples:
           
(function() {
    console.log('Method 1: IIFE using parentheses');
})();

(function() {
    console.log('Method 2: IIFE with function keyword');
}());

(() => {
    console.log('Method 3: IIFE using arrow function');
})();

!function() {
    console.log('Method 4: IIFE using "!"');
}();
           `
    },
    {
        q: "What are operators in JS?",
        a: `Operators are special symbols 
        in JavaScript used to perform operations on values and variables. 
        They include arithmetic, logical, relational, and assignment operators.`,
        code:` Example:
           
let a = 10;
let b = 5;

console.log(a + b); // Arithmetic operator: 15
console.log(a > b); // Relational operator: true
console.log(a && b); // Logical operator: 5
let c = a; // Assignment operator: c = 10
           `
    },
    {
        q: "How can I check data type of variables in JS?",
        a: `In JavaScript, you can use the typeof operator to check the type of a variable.`,
           code:`Example:
           
let num = 42;
let str = "Hello, World!";
let isTrue = true;

console.log(typeof num); // : "number"
console.log(typeof str); // Output: "string"
console.log(typeof isTrue); // Output: "boolean"
           `
    },
    {
        q: "Explain data types in JavaScript?",
        a: `JavaScript has several data types: 
            1. Primitive Types: Number, String, Boolean, Undefined, Null, Symbol, BigInt
            2. Non-Primitive Types: Object (including Arrays, Functions, Dates, etc.)`,
            
            code: `Example:
           
let num = 42; // Number
let str = "Hello, World!"; // String
let isTrue = true; // Boolean
let obj = { name: "John", age: 30 }; // Object
let arr = [1, 2, 3]; // Array
let func = function() { return 'Hello'; }; // Function
           `
    },
    {
        q: "What is hoisting? Give examples.",
        a: `Hoisting is a JavaScript behavior where variable and function 
        declarations are moved to the top of their scope during compilation. 
            However, only declarations are hoisted, not initializations.`,
            
            code:`Example:
           
console.log(x); // undefined (due to hoisting)
var x = 5;

foo(); // Works fine because function declarations are hoisted
function foo() {
  console.log('Hello from foo!');
}
           `
    },
    {
        q: "What is closure? Give examples.",
        a: `A closure is a function
         that remembers its lexical 
         scope even when the function is executed outside that scope.`,
           code: `Example:
           
function outer() {
    let count = 0;
    return function inner() {
        count++;
        console.log(count);
    };
}

const counter = outer();
counter(); // Output: 1
counter(); // Output: 2
           `
    },
    {
        q: "What is stale closure? Give examples.",
        a: `A stale closure occurs when the inner 
        function remembers a variable that has changed 
        in the outer function, but the value is "stale" or outdated in the closure.`,
           code:` Example:
           
function createCounter() {
    let count = 0;
    setTimeout(function() {
        console.log(count); // Stale closure: count is 0
    }, 1000);
    count = 5;
}

createCounter(); // Output: 0 (stale closure)
           `
    },
    {
        q: "Explain currying, its use case, and its benefits.",
        a: `Currying is a technique where a function that takes
         multiple arguments is transformed into a series of functions that each take a single argument.
            
            Use case: Useful when you want to create a function that can be partially applied.
            
            Benefits: It can help reduce redundancy and make the code more reusable.`,
            
            code:`Example:
           
function multiply(a) {
    return function(b) {
        return a * b;
    };
}

const multiplyBy2 = multiply(2);
console.log(multiplyBy2(3)); // Output: 6
           `
    },
    {
        q: "What is an IIFE?",
        a: `An IIFE (Immediately Invoked Function Expression)
         is a function that is defined and executed immediately after its declaration. 
         It’s often used to create a new scope to avoid polluting the global namespace.`,
            
            code:`Example:
           
(function() {
    console.log('I am an IIFE!');
})(); // Output: I am an IIFE!
           `
    },
    {
        q: "Give 4 ways to create an IIFE.",
        a: `You can create an IIFE in several ways:
            1. Using parentheses around the function expression
            2. Using the function keyword followed by parentheses
            3. Using the arrow function syntax
            4. Using an anonymous function`,
            
            code:`Examples:
           
(function() {
    console.log('Method 1: IIFE using parentheses');
})();

(function() {
    console.log('Method 2: IIFE with function keyword');
}());

(() => {
    console.log('Method 3: IIFE using arrow function');
})();

!function() {
    console.log('Method 4: IIFE using "!"');
}();
           `
    },
    {
        q: "What are operators in JS?",
        a: `Operators are special symbols in JavaScript used to perform operations on values and variables. They include arithmetic, logical, relational, and assignment operators.`,
            
          code:`  Example:
           
let a = 10;
let b = 5;

console.log(a + b); // Arithmetic operator: 15
console.log(a > b); // Relational operator: true
console.log(a && b); // Logical operator: 5
let c = a; // Assignment operator: c = 10
           `
    },
    {
        q: "How can I check data type of variables in JS?",
        a: `In JavaScript, you can use the \`typeof\` operator to check the type of a variable.`,
            
           code:` Example:
           
let num = 42;
let str = "Hello, World!";
let isTrue = true;

console.log(typeof num); // Output: "number"
console.log(typeof str); // Output: "string"
console.log(typeof isTrue); // Output: "boolean"
           `
    },
    {
        q: "Explain Abstract Equality in JavaScript. By Abstract Equality I mean ==. How == is different from ===",
        a: `Abstract Equality (==) compares two values for equality but allows type coercion, meaning it converts the operands to the same type before comparison.
            In contrast, Strict Equality (===) checks both the value and the type without performing type coercion.`,
            
            code:`Example:
           
console.log(5 == '5');  // true (type coercion)
console.log(5 === '5'); // false (different types)
           `
    },
    {
        q: "Explain Execution Context",
        a: `An execution context is an abstract concept that holds information about the environment in which the current code is being evaluated. It has two types:
            1. Global Execution Context: Default context where all JavaScript code runs.
            2. Function Execution Context: Created whenever a function is called.`,

            code:`Example:
           
function example() {
    console.log('Inside the function');
}

example(); // Function execution context is created
           `
    },
    {
        q: "What is Lexical Scope?",
        a: `Lexical Scope refers to the scope that is determined by the physical structure of the code, specifically where the function was declared, not where it is executed.`,
            
           code:` Example:
           
function outer() {
    let outerVar = "I'm outside!";
    function inner() {
        console.log(outerVar); // Lexical scope allows access to outerVar
    }
    inner();
}

outer(); // Output: I'm outside!
           `
    },
    {
        q: "Explain this keyword",
        a: `The \`this\` keyword refers to the context in which a function is executed. It can represent different things depending on how the function is called.`,
        code:` Example:
           
function showThis() {
    console.log(this);
}

showThis(); // In the global context, \`this\` refers to the global object (window in browsers)
           `
    },
    {
        q: "What is call, bind, and apply?",
        a: `\`call()\`, \`bind()\`, and \`apply()\` are methods used to set the \`this\` value for a function:
            - \`call()\` invokes the function immediately.
            - \`apply()\` invokes the function immediately, but takes arguments as an array.
            - \`bind()\` returns a new function with a specified \`this\` value, but does not invoke it immediately.`,

           code:` Example:
           
function greet(name) {
    console.log("Hello, name");
}

greet.call(null, 'Alice'); // Output: Hello, Alice!
greet.apply(null, ['Bob']); // Output: Hello, Bob!
const greetBound = greet.bind(null, 'Charlie');
greetBound(); // Output: Hello, Charlie!
           `
    },
    {
        q: "Explain what is the new Keyword.",
        a: `The \`new\` keyword is used to create an instance of an object that has a constructor function. It allows for creating objects with properties and methods defined in the constructor.`,
            
            code:`Example:
           
function Person(name) {
    this.name = name;
}
let person = new Person("Alice");
console.log(person.name); // Output: Alice
           `
    },
    {
        q: "What are prototypes in JS?",
        a: `In JavaScript, every object has a prototype, which is another object that the current object can inherit properties and methods from.`,
            
            code:`Example:
           
function Person(name) {
    this.name = name;
}

Person.prototype.greet = function() {
    console.log("Hello, this.name");
};

let person = new Person("Alice");
person.greet(); // Output: Hello, Alice!
           `
    },
    {
        q: "Explain difference between __proto__, prototype, [[prototype]]",
        a: `- __proto__ is the internal property that refers to an object's prototype.
            - prototype is a property of a constructor function that points to the prototype object.
            - [[prototype]] is an internal property used to reference the prototype chain.`,
            
           code:` Example:
           
function Animal() {}
Animal.prototype = { sound: 'Roar' };

const lion = new Animal();
console.log(lion.__proto__); // Animal.prototype
           `
    },
    {
        q: "What is prototypical inheritance? How it is different from classical inheritance.",
        a: `Prototypical inheritance is a method of inheritance where objects inherit properties and methods from other objects. It differs from classical inheritance, where classes inherit from other classes.`,
            
           code:` Example:
           
function Animal() {}
Animal.prototype.speak = function() { console.log("Animal sound!"); };

function Dog() {}
Dog.prototype = new Animal();
const dog = new Dog();
dog.speak(); // Output: Animal sound!
           `
    },
    {
        q: "What is the difference between var, let, and const?",
        a: `- var is function-scoped or globally-scoped and can be re-declared.
            - let is block-scoped and can be reassigned but not re-declared in the same scope.
            - const is block-scoped and cannot be reassigned or re-declared.`,

            code:`Example:
           
var a = 5;
let b = 10;
const c = 15;

a = 20; // works
b = 25; // works
// c = 30; // Error: Assignment to constant variable
           `
    },
    {
        q: "What are Symbols in JS?",
        a: `Symbols are unique and immutable data types introduced in ES6, primarily used as object property keys to avoid name conflicts.`,
            
           code:` Example:
           
const sym1 = Symbol('description');
const sym2 = Symbol('description');
console.log(sym1 === sym2); // Output: false (unique)
           `
    },
    {
        q: "What is the spread and rest concept in JS?",
        a: `Spread syntax (\`...\`) allows an expression to expand in places like function arguments or array literals. Rest syntax (\`...\`) collects multiple elements into a single array or object.`,
            
           code:` Example:
const arr = [1, 2, 3];
const newArr = [...arr, 4, 5]; // Spread
console.log(newArr); // Output: [1, 2, 3, 4, 5]

function sum(...args) { // Rest
    return args.reduce((acc, val) => acc + val, 0);
}
console.log(sum(1, 2, 3)); // Output: 6
           `
    },
    {
        q: "Explain destructuring.",
        a: `Destructuring is a convenient way to extract multiple values from arrays or objects and assign them to variables in a single statement.`,
            
            code:`Example:
const person = { name: 'Alice', age: 30 };
const { name, age } = person; // Object destructuring
console.log(name, age); // Output: Alice 30

const arr = [1, 2, 3];
const [a, b] = arr; // Array destructuring
console.log(a, b); // Output: 1 2
           `
    },
    {
        q: "Explain difference between || and ??",
        a: `The logical OR || operator returns the first truthy value or the last value if none is truthy. 
            The nullish coalescing (?.) operator returns the first defined value (not null or undefined).`,
            
           code:` Example:
console.log(null || 'default'); // Output: default
console.log(undefined ?? 'default'); // Output: default
           `
    },
    {
        q: "What is optional chaining?",
        a: `Optional chaining (\`?.\`) allows you to safely access deeply nested properties of an object without causing an error if any part of the chain is null or undefined.`,
            
           code:` Example:
const obj = { user: { profile: { name: 'Alice' } } };
console.log(obj.user?.profile?.name); // Output: Alice
console.log(obj.user?.address?.city); // Output: undefined
           `
    },
    {
        q: "What is functional programming?",
        a: `Functional programming is a programming paradigm where functions are first-class citizens, and computation is treated as the evaluation of mathematical functions.`,
            
            code:`Example:
const add = (a, b) => a + b;
const result = add(5, 3);
console.log(result); // Output: 8
           `
    },
    {
        q: "What is the difference between reduce and reduceRight?",
        a: `\`reduce()\` processes the array from left to right, while \`reduceRight()\` processes the array from right to left.`,
            
           code:` Example:
const arr = [1, 2, 3, 4];

const leftToRight = arr.reduce((acc, curr) => acc + curr, 0); // Output: 10
const rightToLeft = arr.reduceRight((acc, curr) => acc + curr, 0); // Output: 10
           `
    },
    {
        q: "What are callbacks?",
        a: `Callbacks are functions passed as arguments to other functions, to be executed later once a task is completed.`,
            
            code:`Example:
function fetchData(callback) {
    setTimeout(() => {
        callback("Data fetched!");
    }, 1000);
}

fetchData((message) => {
    console.log(message); // Output: Data fetched!
});
           `
    },
    {
        q: "Explain inversion of control.",
        a: `Inversion of control is a design principle where the control of the flow of execution is handed over to another component or framework.`,
            
           code: `Example:
function fetchData(callback) {
    setTimeout(() => {
        callback("Data fetched!");
    }, 1000);
}

// The caller has control over what happens with the data fetched
fetchData((message) => {
    console.log(message);
});
           `
    },
    {
        q: "What are promises?",
        a: `Promises in JavaScript are used to handle asynchronous operations. They represent a value that may be available now, or in the future, or never. Promises have three states: pending, resolved, or rejected.`,
            
           code :`Example:
let promise = new Promise((resolve, reject) => {
    let success = true;
    if(success) {
        resolve("The operation was successful");
    } else {
        reject("The operation failed");
    }
});

promise.then((result) => {
    console.log(result); // Output: The operation was successful
}).catch((error) => {
    console.log(error); // Output: The operation failed
});
           `
    },
    {
        q: "What are the different states of promises?",
        a: `Promises have three possible states:
            1. Pending: The initial state, neither fulfilled nor rejected.
            2. Resolved (Fulfilled): The operation completed successfully.
            3. Rejected: The operation failed.`,
            
           code:` Example:
let promise = new Promise((resolve, reject) => {
    let success = true;
    if(success) {
        resolve("Success");
    } else {
        reject("Failure");
    }
});
           `
    },
    {
        q: "When does the finally block get called under promises?",
        a: `The finally block is called after the promise is settled (either resolved or rejected), regardless of the outcome. It is useful for cleanup operations.`,
            
           code:` Example:
let promise = new Promise((resolve, reject) => {
    let success = true;
    if(success) {
        resolve("Operation completed");
    } else {
        reject("Operation failed");
    }
});

promise.then(result => {
    console.log(result);
}).catch(error => {
    console.log(error);
}).finally(() => {
    console.log("Cleanup task");
});
           `
    },
    {
        q: "How can I handle errors using try catch in JS?",
        a: `The try...catch statement allows you to test a block of code for errors, and handle them without terminating the program.`,
            
            code:`Example:
try {
    let x = y + 10; // This will throw an error because y is not defined
} catch (error) {
    console.log("An error occurred: " + error.message);
}
           `
    },
    {
        q: "What is tagged template literal?",
        a: `A tagged template literal is a special kind of template literal that can be used to modify or process the output of a template string.`,
            
           code:`Example:
function tag(strings, ...values) {
    return strings.reduce((result, str, i) => result + str + (values[i] || ''), '');
}

let message = tag "Hello, ${'World'}!";
console.log(message); // Output: Hello, World!
           `
    },
    {
        q: "How does this work inside the arrow function?",
        a: `In arrow functions, the value of this is lexically bound, meaning it takes the value of this from the surrounding scope.`,
            
           code:` Example:
const obj = {
    value: 10,
    method: function() {
        setTimeout(() => {
            console.log(this.value); // 'this' refers to the obj context
        }, 1000);
    }
};

obj.method(); // Output: 10
           `
    },
    {
        q: "What is the difference between an arrow and normal function? Explain 7 Differences.",
        a: `1. Syntax: Arrow functions have a shorter syntax.
            2. this Binding: Arrow functions do not have their own this, while normal functions do.
            3. Constructor: Normal functions can be used as constructors, arrow functions cannot.
            4. arguments Object: Normal functions have access to the arguments object, while arrow functions do not.
            5. Return: Arrow functions return implicitly if there's only one expression.
            6. Method Assignment: Arrow functions cannot be used as methods of objects.
            7. new Keyword: Normal functions can be called with the "new" keyword, but arrow functions cannot.`,
            
            code:`Example:
let normalFunc = function() {
    console.log(this);
};

let arrowFunc = () => {
    console.log(this);
};
           `
    },
    {
        q: "Explain Sets. How they are different from arrays.",
        a: `A Set is a collection of unique values. Unlike arrays, Sets do not allow duplicate elements.`,
            
            code:`Example:
let set = new Set([1, 2, 3, 4, 4]);
console.log(set); // Output: Set {1, 2, 3, 4}
           `
    },
    {
        q: "What are the arguments keywords present in all functions in JavaScript?",
        a: `The arguments object is an array-like object available within all non-arrow functions. It contains the passed arguments.`,
            
           code: `Example:
function showArguments() {
    console.log(arguments);
}

showArguments(1, 2, 3); // Output: [1, 2, 3]
           `
    },
    {
        q: "What is “use strict” and what it does?",
        a: `The "use strict" directive is used to enforce stricter parsing and error handling in JavaScript. It prevents certain errors and disables some features that are considered bad practice.`,
            
           code:` Example:
"use strict";
x = 10; // Throws an error because variables must be declared first
           `
    },
    {
        q: "How does the for...of loop differ from the for...in loop?",
        a: `The for...in loop iterates over the keys (property names) of an object, whereas the "for...of" loop iterates over the values of an iterable (like arrays).`,
            
           code:` Example:
let arr = [1, 2, 3];

for (let index in arr) {
    console.log(index); // Output: 0, 1, 2 (keys)
}

for (let value of arr) {
    console.log(value); // Output: 1, 2, 3 (values)
}
           `
    },
    {
        q: "How does the async/await syntax simplify asynchronous code in JavaScript?",
        a: `The "async/await" syntax makes asynchronous code easier to write and read by allowing you to write asynchronous code in a synchronous manner.`,
            
           code:` Example:
async function fetchData() {
    let response = await fetch('https://api.example.com');
    let data = await response.json();
    console.log(data);
}
           `
    },
    {
        q: "Explain the difference between map and filter.",
        a: `Both "map" and "filter" are array methods that return a new array. 
            - "map" is used to apply a function to each element and return the transformed array.
            - "filter" is used to apply a function and return only the elements that satisfy a condition.`,
            
            code:`Example:
let arr = [1, 2, 3, 4, 5];

let doubled = arr.map(x => x * 2); // [2, 4, 6, 8, 10]
let even = arr.filter(x => x % 2 === 0); // [2, 4]
           `
    },
    {
        q: "What Map and WeakMap in JavaScript?",
        a: `- "Map" is an object that stores key-value pairs, where keys can be of any data type.
            - "WeakMap" is similar to "Map", but its keys are weakly referenced, meaning that if the key is garbage-collected, the entry is removed from the "WeakMap".
            
            Example:
let map = new Map();
map.set("name", "Alice");

let weakMap = new WeakMap();
let obj = {};
weakMap.set(obj, "data");
           `
    },
    {
        q: "What are WeakRefs in JavaScript?",
        a: `A "WeakRef" is a reference to an object that does not prevent that object from being garbage-collected.`,
            
            code:`Example:
let obj = {};
let weakRef = new WeakRef(obj);
console.log(weakRef.deref()); // Output: obj (if it hasn't been garbage-collected yet)
           `
    },
    {
        q: "What is the difference between setTimeout and requestAnimationFrame?",
        a: `- "setTimeout" is used to schedule a function to be executed after a specified delay in milliseconds.
           - "requestAnimationFrame" is used to schedule a function to be executed before the next repaint of the browser, typically used for animations to ensure smooth rendering.`,

          code:` Example:
"setTimeout"(() => {
    console.log("This will run after 1 second");
}, 1000);

"requestAnimationFrame"(() => {
    console.log("This will run before the next repaint");
});
          `
    },
    {
        q: "How does event delegation work in the context of JavaScript event handling?",
        a: `Event delegation is a technique in JavaScript where instead of attaching an event listener to each child element, we attach a single event listener to a parent element and take advantage of event bubbling to handle events for child elements.`,

           code:`Example:
document.querySelector("#parent").addEventListener("click", function(event) {
    if (event.target && event.target.matches("button.className")) {
        console.log("Button clicked");
    }
});
          `
    },
    {
        q: "Explain the differences between the DOMContentLoaded and load events.",
        a: `- The "DOMContentLoaded" event fires when the HTML is completely loaded and parsed, but before external resources (like images and stylesheets) have finished loading.
           - The "load" event fires when the entire page, including all dependent resources (images, stylesheets, etc.), has fully loaded.`,

           code:`Example:
document.addEventListener("DOMContentLoaded", () => {
    console.log("DOM fully loaded");
});

window.addEventListener("load", () => {
    console.log("Page fully loaded");
});
          `
    },
    {
        q: "How can you stop event propagation in JavaScript?",
        a: `You can stop event propagation by using the "stopPropagation" method of the event object. This prevents the event from bubbling up or capturing down the DOM tree.`,

         code:`  Example:
document.querySelector("button").addEventListener("click", (event) => {
    event.stopPropagation(); // Prevents the event from propagating
    console.log("Button clicked");
});
          `
    },
    {
        q: "Describe the purpose of the addEventListener method and how it works.",
        a: `The "addEventListener" method is used to attach an event handler to a specified element for a specific event type. It allows multiple event listeners for the same event on the same element, unlike using the "onclick" property.`,

          code:` Example:
document.querySelector("button").addEventListener("click", () => {
    console.log("Button clicked");
});
          `
    },
    {
        q: "What is the event object, and how is it used in JavaScript event handling?",
        a: `The event object is automatically passed to event handler functions and contains information about the event (such as the type of event, the target element, and more). It's used to manage event-specific details like stopping propagation or preventing the default action.`,

         code:`  Example:
document.querySelector("button").addEventListener("click", (event) => {
    console.log(event.target); // The element that triggered the event
});
          `
    },
    {
        q: "Explain the differences between the onclick attribute and addEventListener for handling click events.",
        a: `- The "onclick" attribute directly adds an event handler in HTML, but it only allows one handler per event.
           - "addEventListener" is a more flexible method, allowing multiple event listeners to be added for the same event type.`,

          code: `Example:
document.querySelector("button").onclick = function() {
    console.log("Button clicked with onclick");
};

document.querySelector("button").addEventListener("click", () => {
    console.log("Button clicked with addEventListener");
});
          `
    },
    {
        q: "Explain the concept of bubbling and capturing in event propagation.",
        a: `- Event bubbling occurs when an event starts from the innermost element and propagates outward to the root of the document.
           - Event capturing (or trickling) occurs when the event starts from the outermost element and propagates inward.`,

           code:`Example:
document.querySelector("div").addEventListener("click", () => {
    console.log("Captured!");
}, true); // Capture phase

document.querySelector("div").addEventListener("click", () => {
    console.log("Bubbled!");
}); // Bubble phase
           `
    },
    {
        q: "How can you simulate a click event using JavaScript?",
        a: `You can simulate a click event by creating a new "Event" object and using the "click()" method.`,

          code:` Example:
let button = document.querySelector("button");
button.addEventListener("click", () => {
    console.log("Button clicked!");
});

// Simulating a click event
button.click(); // Output: Button clicked!
           `
    },
    {
        q: "Explain the differences between the keyup, keydown, and keypress events.",
        a: `- The "keydown" event fires when a key is pressed down.
           - The "keypress" event is fired when a key that produces a character value is pressed down (e.g., alphabetic keys).
           - The "keyup" event fires when a key is released.`,

          code:` Example:
document.addEventListener("keydown", () => {
    console.log("Key down");
});
document.addEventListener("keypress", () => {
    console.log("Key press");
});
document.addEventListener("keyup", () => {
    console.log("Key up");
});
           `
    },
    {
        q: "What is the purpose of the preventDefault method in JavaScript events?",
        a: `The "preventDefault" method is used to prevent the default behavior of an event (e.g., preventing a form from submitting, stopping a link from navigating).`,

           code:`Example:
document.querySelector("form").addEventListener("submit", (event) => {
    event.preventDefault(); // Prevents the form from submitting
    console.log("Form submission prevented");
});
           `
    },
    {
        q: "Difference between querySelector and document.getElementsByClassName",
        a: `- "querySelector" returns the first element that matches a given CSS selector.
           - "getElementsByClassName" returns a live HTMLCollection of all elements with the specified class name.`,
           
          code:` Example:
let element1 = document.querySelector(".className"); // Returns the first element with className
let elements2 = document.getElementsByClassName("className"); // Returns all elements with className
           `
    },
    {
        q: "forEach Polyfill",
        a: `
The "forEach" method allows you to iterate over elements in an array, applying a callback function to each element. Here’s a simple polyfill:`,

code: `
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(callback) {
        for (let i = 0; i < this.length; i++) {
            callback(this[i], i, this);
        }
    };
}

This polyfill checks if "forEach" exists, and if it doesn't, it adds a custom implementation using a basic loop.

Example:

const arr = [1, 2, 3];
arr.forEach((item) => console.log(item)); // Output: 1, 2, 3
`
    },
    {
        q: "Map Polyfill",
        a: `
The "map" method allows you to create a new array by transforming the elements of an existing one. Here's the polyfill:`,

code: `
if (!Array.prototype.map) {
    Array.prototype.map = function(callback) {
        const result = [];
        for (let i = 0; i < this.length; i++) {
            result.push(callback(this[i], i, this));
        }
        return result;
    };
}

This polyfill creates a new array by applying a callback function to each element.

Example:

const arr = [1, 2, 3];
const doubled = arr.map(x => x * 2);
console.log(doubled); // Output: [2, 4, 6]
`
    },
    {
        q: "Filter Polyfill",
        a: `
The "filter" method creates a new array with all elements that pass the test implemented by the provided function. Here’s the polyfill:`,

code:`
if (!Array.prototype.filter) {
    Array.prototype.filter = function(callback) {
        const result = [];
        for (let i = 0; i < this.length; i++) {
            if (callback(this[i], i, this)) {
                result.push(this[i]);
            }
        }
        return result;
    };
}

This polyfill returns a new array with the elements that satisfy the condition in the callback function.

Example:

const arr = [1, 2, 3, 4];
const evenNumbers = arr.filter(x => x % 2 === 0);
console.log(evenNumbers); // Output: [2, 4]
`
    },
    {
        q: "Reduce Polyfill",
        a: `
The "reduce" method applies a function to each element in an array to reduce it to a single value. Here’s the polyfill:`,

code:`
if (!Array.prototype.reduce) {
    Array.prototype.reduce = function(callback, initialValue) {
        let accumulator = initialValue !== undefined ? initialValue : this[0];
        for (let i = initialValue === undefined ? 1 : 0; i < this.length; i++) {
            accumulator = callback(accumulator, this[i], i, this);
        }
        return accumulator;
    };
}

This polyfill uses a loop to reduce the array to a single value, applying the callback on each iteration.

Example:

const arr = [1, 2, 3];
const sum = arr.reduce((acc, curr) => acc + curr, 0);
console.log(sum); // Output: 6
`
    },
    {
        q: "Some and Every Function Polyfill",
        a: `
"some" checks if at least one element passes the test, and "every" checks if all elements pass the test. Here are the polyfills:`,

code: `
if (!Array.prototype.some) {
    Array.prototype.some = function(callback) {
        for (let i = 0; i < this.length; i++) {
            if (callback(this[i], i, this)) return true;
        }
        return false;
    };
}

if (!Array.prototype.every) {
    Array.prototype.every = function(callback) {
        for (let i = 0; i < this.length; i++) {
            if (!callback(this[i], i, this)) return false;
        }
        return true;
    };
}

Example:

const arr = [1, 2, 3];
console.log(arr.some(x => x > 2)); // Output: true
console.log(arr.every(x => x > 0)); // Output: true
`
    },
    {
        q: "Push and Pop Polyfill",
        a: `
The "push" method adds one or more elements to the end of an array, and "pop" removes the last element. Here’s the polyfill:`,

code:`
if (!Array.prototype.push) {
    Array.prototype.push = function(...elements) {
        for (let i = 0; i < elements.length; i++) {
            this[this.length] = elements[i];
        }
        return this.length;
    };
}

if (!Array.prototype.pop) {
    Array.prototype.pop = function() {
        if (this.length === 0) return undefined;
        const last = this[this.length - 1];
        this.length = this.length - 1;
        return last;
    };
}

Example:

const arr = [1, 2, 3];
arr.push(4); // arr = [1, 2, 3, 4]
console.log(arr.pop()); // Output: 4
console.log(arr); // Output: [1, 2, 3]
`
    },
    {
        q: "Slice and Splice Polyfill",
        a: `
- "slice" creates a shallow copy of a portion of an array.
- "splice" changes the contents of an array by removing or replacing elements.`,

code: `Polyfill for "slice":


if (!Array.prototype.slice) {
    Array.prototype.slice = function(begin, end) {
        const result = [];
        end = end || this.length;
        for (let i = begin; i < end; i++) {
            result.push(this[i]);
        }
        return result;
    };
}


Polyfill for "splice":


if (!Array.prototype.splice) {
    Array.prototype.splice = function(start, deleteCount, ...items) {
        const removed = [];
        for (let i = start; i < start + deleteCount; i++) {
            removed.push(this[i]);
        }
        this.length = this.length - deleteCount;
        for (let i = this.length - 1; i >= start; i--) {
            this[i + items.length] = this[i];
        }
        for (let i = 0; i < items.length; i++) {
            this[start + i] = items[i];
        }
        return removed;
    };
}

Example:

const arr = [1, 2, 3, 4];
console.log(arr.slice(1, 3)); // Output: [2, 3]
arr.splice(1, 2, 5, 6);
console.log(arr); // Output: [1, 5, 6, 4]
`
    },
    {
        q: "Call, Bind and Apply Polyfill",
        a: `
"call", "bind", and "apply" are methods for changing the context of a function. Here's the polyfill:`,

code: `
if (!Function.prototype.call) {
    Function.prototype.call = function(context, ...args) {
        context = context || globalThis;
        context.fn = this;
        const result = context.fn(...args);
        delete context.fn;
        return result;
    };
}

if (!Function.prototype.apply) {
    Function.prototype.apply = function(context, args) {
        context = context || globalThis;
        context.fn = this;
        const result = context.fn(...args);
        delete context.fn;
        return result;
    };
}

if (!Function.prototype.bind) {
    Function.prototype.bind = function(context, ...args) {
        return (...innerArgs) => {
            return this.apply(context, [...args, ...innerArgs]);
        };
    };
}

Example:

function greet(name) {
    console.log("Hello,name");
}
greet.call(null, "John"); // Output: Hello, John
`
    },
    {
        q: "Promise.all Polyfill",
        a: `
The "Promise.all" method takes an array of promises and returns a single promise that resolves when all the promises have resolved. Here’s the polyfill:`,

code:`
if (!Promise.all) {
    Promise.all = function(promises) {
        return new Promise((resolve, reject) => {
            let count = 0;
            const results = [];
            for (let i = 0; i < promises.length; i++) {
                promises[i].then(
                    result => {
                        results[i] = result;
                        count++;
                        if (count === promises.length) {
                            resolve(results);
                        }
                    },
                    error => reject(error)
                );
            }
        });
    };
}

Example:

const p1 = Promise.resolve(3);
const p2 = Promise.resolve(2);
const p3 = Promise.resolve(1);
Promise.all([p1, p2, p3]).then(values => console.log(values)); // Output: [3, 2, 1]
`
    },
    {
        q: "Debounce Polyfill",
        a: `
Debounce is a technique used to limit the rate at which a function can fire. Here’s the polyfill:`,

code:`
function debounce(func, delay) {
    let timeout;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, arguments), delay);
    };
}

Example:

const log = debounce(() => console.log("Hello!"), 2000);
log();
`
    },
    {
        q: "Throttle Polyfill",
        a: `
Throttle is a technique used to ensure a function is only called at most once in a specified period. Here’s the polyfill:`,

code:`
function throttle(func, delay) {
    let timeout;
    let lastExecution = 0;
    return function() {
        const now = new Date().getTime();
        if (now - lastExecution >= delay) {
            func.apply(this, arguments);
            lastExecution = now;
        }
    };
}

Example:

const log = throttle(() => console.log("Hello!"), 2000);
log();
`
    },
    {
        q: "JSON.stringify Polyfill",
        a: `
The "JSON.stringify" method converts a JavaScript object into a JSON string. Here's a simple polyfill:`,

code:`
if (!JSON.stringify) {
    JSON.stringify = function(value) {
        return value === null ? "null" : typeof value === "object" ? JSON.stringify(value) : String(value);
    };
}

Example:

const obj = { name: "John", age: 30 };
console.log(JSON.stringify(obj)); // Output: {"name":"John","age":30}
`
    },
    {
        q: "Array.reduce() method",
        a: "Array.reduce() is one of the most powerful methods available that can be used to perform different types of actions like segregation, aggregation, running things in sequence/series, etc.",
        code: `
        // Aggregation Example: Sum all elements of the array
        const arr = [1, 2, 3, 4];
        const sum = arr.reduce((previousValue, currentValue) => {
            const nextValue = previousValue + currentValue;
            return nextValue;
        }, 0);
        console.log(sum); // 10
        
        // Segregation Example: Group by floored value
        const arr2 = [1.1, 1.2, 1.3, 2.2, 2.3, 2.4];
        const segregate = arr2.reduce((previousValue, currentValue) => {
            const floored = Math.floor(currentValue);
            if (!previousValue[floored]) {
                previousValue[floored] = [];
            }
            previousValue[floored].push(currentValue);
            return previousValue;
        }, {});
        console.log(segregate);
        // {1: [1.1, 1.2, 1.3], 2: [2.2, 2.3, 2.4]}
        
        // Running functions in sequence Example
        const upperCase = (str) => str.toUpperCase();
        const reverse = (str) => str.split('').reverse().join('');
        const append = (str) => "Hello " + str;

        const arr3 = [upperCase, reverse, append];
        const initialValue = "learnersbucket";
        const finalValue = arr3.reduce((previousValue, currentElement) => {
            const newValue = currentElement(previousValue);
            return newValue;
        }, initialValue);
        console.log(finalValue); // "Hello TEKCUBSRENRAEL"
        `
    },
    {
        q: "Function & this",
        a: "Functions are the building blocks of JavaScript, it is one of the programming languages that uses functional programming at the core. As easy as it is to use the functions, understanding this keyword is that complex. Because the value of this is decided at the execution time, unlike other programming languages. Majorly there are four different ways to invoke a function in JavaScript.",
        code: `
          1. As a normal function:
            function example() {
              console.log("Hello World!");
            };
            example(); // "Hello World!"
          
          2. As a method:
            const obj = {
              blog: "learnersbucket",
              displayBlog: function() {
                console.log(this.blog);
              }
            };
            obj.displayBlog(); // "learnersbucket"
    
          3. As a constructor:
            const number = new Number("10");
            console.log(number); // 10
    
          4. Indirectly using call, apply, & bind:
            function example(arg1, arg2) {
              console.log(arg1 + arg2);
            };
            example.call(undefined, 10, 20); // 30
        `
      },
      {
        q: "Value of this when invoked as a normal function",
        a: "The value of this in the function invocation refers to the global object. window in the browser and global in Node.js.",
        code: `
          function example() {
            console.log(this === window); // true
          }
          example();
        `
      },
      {
        q: "Strict mode",
        a: "If you invoke the function with strict mode, the value of this will be undefined.",
        code: `
          function example() {
            "use strict"
            console.log(this === undefined); // true
          }
          example();
        `
      },
      {
        q: "IIFE (Immediately Invoked Function Expression)",
        a: "When we immediately invoke the function, it is invoked as a normal function thus depending upon the mode, the value of this inside it is decided.",
        code: `
          // normal mode
          (function example() {
            console.log(this === window); // true
          })();
    
          // strict mode
          (function example() {
            "use strict"
            console.log(this === undefined); // true
          })();
        `
      },
      {
        q: "Value of this keyword when invoked as a method",
        a: "When a function is declared inside an object, the value of this inside that function will refer to the object it is declared in.",
        code: `
          const example = {
            blog: 'learnersbucket',
            displayBlog: function() {
              console.log(this === example); // true
              console.log(this.blog); // "learnersbucket"
            }
          };
          example.displayBlog();
        `
      },
      {
        q: "value of this keyword with Fat arrow function",
        a: "The fat arrow function does not have its own this; it accesses this in its nearest scope.",
        code: `
          const example = {
            blog: 'learnersbucket',
            displayBlog: function() {
              const inner = () => {
                console.log(this === example); // true
                console.log(this.blog); // "learnersbucket"
              };
              inner();
            }
          };
          example.displayBlog();
        `
      },
      {
        q: "Using call() method",
        a: "We can change the value of this inside a function by calling it indirectly with the call method.",
        code: `
          const example = {
            blog: 'learnersbucket',
            displayBlog: function() {
              function inner() {
                console.log(this === example); // true
                console.log(this.blog); // "learnersbucket"
              }
              inner.call(this);
            }
          };
          example.displayBlog();
        `
      },
      {
        q: "Value of this keyword when invoked as a constructor",
        a: "The value of this in the function invoked as a constructor refers to a new object, which has the value passed as an argument. Each instance creates a new object.",
        code: `
          function Example(blog) {
            this.blog = blog;
            this.displayBlog = function() {
              console.log(this.blog);
            };
          }
          const example = new Example("learnersbucket");
          example.displayBlog(); // "learnersbucket"
    
          const example2 = new Example("MDN");
          example2.displayBlog(); // "MDN"
          console.log(example === example2); // false
        `
      },
      {
        q: "Value of this keyword when invoked indirectly",
        a: "When the function is invoked indirectly, the value of this is what is passed as an argument to the call, apply, & bind method.",
        code: `
          const exampleObj = { blog: 'learnersbucket' };
    
          function example(name) {
            console.log(\`\${name} runs \${this.blog}\`);
          }
    
          example.call(exampleObj, 'Prashant'); // "Prashant runs learnersbucket"
          example.apply(exampleObj, ['Prashant']); // "Prashant runs learnersbucket"
        `
      },
      {
        q: "value of this keyword when Permanent binding using bind",
        a: "When using bind, we can create a new function with the new values and store it in a variable, then use it further. It creates fresh permanent binding without affecting the original function.",
        code: `
          const exampleObj = { name: 'prashant' };
    
          function example(blog) {
            console.log(\`\${this.name} runs \${blog}\`);
          }
    
          const bounded = example.bind(exampleObj);
          bounded('learnersbucket'); // "Prashant runs learnersbucket"
          bounded('MDN'); // "Prashant runs MDN"
        `
      }, 
      {
        q: "What is the polyfill for `Promise.all()`?",
        a: "`Promise.all()` accepts an array of promises and returns a promise that resolves when all the promises are fulfilled or when the iterable contains no promises. If any promise rejects, it rejects with the reason of the first rejected promise.",
        code: `
          const myPromiseAll = function(taskList) {
            const results = [];
            let promisesCompleted = 0;
            
            return new Promise((resolve, reject) => {
              taskList.forEach((promise, index) => {
                promise
                  .then((val) => {
                    results[index] = val;
                    promisesCompleted += 1;
                    
                    if (promisesCompleted === taskList.length) {
                      resolve(results);
                    }
                  })
                  .catch(error => {
                    reject(error);
                  });
              });
            });
          }
        `
      },
      {
        q: "What is the polyfill for `Promise.any()`?",
        a: "`Promise.any()` takes an iterable of Promise objects. It returns a single promise that fulfills as soon as any of the promises in the iterable fulfills, with the value of the fulfilled promise. If no promises fulfill (i.e., all are rejected), the returned promise is rejected with an AggregateError.",
        code: `
          const any = function(promisesArray) {
            const promiseErrors = new Array(promisesArray.length);
            let counter = 0;
            
            return new Promise((resolve, reject) => {
              promisesArray.forEach((promise) => {
                Promise.resolve(promise)
                  .then(resolve) // resolve, when any of the input promise resolves
                  .catch((error) => {
                    promiseErrors[counter] = error;
                    counter = counter + 1;
                    if (counter === promisesArray.length) {
                      reject(promiseErrors); // All promises rejected
                    }
                  });
              });
            });
          }
        `
      },
      {
        q: "What is the polyfill for `Promise.race()`?",
        a: "`Promise.race()` returns a promise that fulfills or rejects as soon as one of the promises in an iterable fulfills or rejects, with the value or reason from that promise.",
        code: `
          const race = function(promisesArray) {
            return new Promise((resolve, reject) => {
              promisesArray.forEach((promise) => {
                Promise.resolve(promise)
                  .then(resolve, reject)
                  .catch(reject);
              });
            });
          }
        `
      },
      {
        q: "How do you deep flatten an object in JavaScript?",
        a: "To deep flatten an object, recursively check if the value of each key is an object or array. If it's a primitive value, add it to the result. If it's an object or array, recursively flatten it and concatenate the keys appropriately using dot notation for nested objects or array indices.",
        code: `
          const flatten = (obj, prefix = '') => {
            let output = {};
            for (let k in obj) {
              let val = obj[k];
              const newKey = prefix ? \`\${prefix}.\${k}\` : k;
              if (typeof val === 'object') {
                if (Array.isArray(val)) {
                  const { ...arrToObj } = val;
                  const newObj = flatten(arrToObj, newKey);
                  output = { ...output, ...newObj };
                } else {
                  const newObj = flatten(val, newKey);
                  output = { ...output, ...newObj };
                }
              } else {
                output = { ...output, [newKey]: val };
              }
            }
            return output;
          };
        `
      },
      {
        q: "Create a memoizer function",
        a: "Memoization is an optimization technique where the results of expensive function calls are cached based on the input parameters, making subsequent calls faster. It works by storing the result of a function for specific input values and returning the cached result when the same input is encountered again.",
        code: `
          const memoize = function(fn) {
            const cache = {};
            return function() {
              const KEY = JSON.stringify(arguments);
              if (cache[KEY]) {
                return cache[KEY];
              }
              const evaluatedValue = fn(...arguments);
              cache[KEY] = evaluatedValue;
              return evaluatedValue;
            };
          };
          
          // Example usage:
          function factorial(n) {
            if (n === 0 || n === 1) {
              return 1;
            }
            return factorial(n-1) * n;
          }
    
          const memoizedFactorial = memoize(factorial);
          let a = memoizedFactorial(100); // First call, slow
          console.log(a);
          let b = memoizedFactorial(100); // Cached call, faster
          console.log(b);
        `
      },
      {
        q: "Method chaining - Part 1",
        a: "Method chaining allows multiple methods to be called on the same object in a single expression. It works by returning the same object (or `this`) from each method so that the methods can be chained together. The following examples demonstrate method chaining using both objects and functions.",
        code: `
          // Method 1: Using objects
          const calculator = {
            total: 0,
            add: function(val) {
              this.total += val;
              return this;
            },
            subtract: function(val) {
              this.total -= val;
              return this;
            },
            divide: function(val) {
              this.total /= val;
              return this;
            },
            multiply: function(val) {
              this.total *= val;
              return this;
            }
          };
    
          // Usage:
          calculator.add(10).subtract(2).divide(2).multiply(5);
          console.log(calculator.total); // Output: 20
        `
      },
      {
        q: "Method chaining - Part 2",
        a: "In this example, method chaining is used to perform operations like 'lacs', 'crore', 'thousand', etc., by chaining them together to compute a final value. We use function-based closures and constructors to implement this behavior.",
        code: `
          // Method 1: Using function as constructor
          const ComputeAmount = function() {
            this.store = 0;
            this.crore = function(val) {
              this.store += val * Math.pow(10, 7);
              return this;
            };
            this.lacs = function(val) {
              this.store += val * Math.pow(10, 5);
              return this;
            };
            this.thousand = function(val) {
              this.store += val * Math.pow(10, 3);
              return this;
            };
            this.hundred = function(val) {
              this.store += val * Math.pow(10, 2);
              return this;
            };
            this.ten = function(val) {
              this.store += val * 10;
              return this;
            };
            this.unit = function(val) {
              this.store += val;
              return this;
            };
            this.value = function() {
              return this.store;
            };
          };
    
          // Example usage:
          const computeAmount = new ComputeAmount();
          const amount = computeAmount.lacs(15).crore(5).crore(2).lacs(20).thousand(45).crore(7).value();
          console.log(amount); // Output: 143545000
        `
      },
      {
        q: "Implement a currying function for 4 arguments that returns the sum once the limit is reached.",
        a: "This currying function takes 4 arguments and returns the sum when the limit of the arguments is reached. The sum is returned after all the arguments are passed, which is useful for scenarios where you need to perform operations on a fixed number of arguments.",
        code: `
          const curryingSum = (a) => {
            let sum = a;
            const addMore = (b) => {
              sum += b;
              if (arguments.length === 4) {
                return sum;
              }
              return addMore;
            };
            return addMore;
          };
    
          // Example usage:
          console.log(curryingSum(1)(2)(3)(4)); // Output: 10
        `
      },
      {
        q: "Create a JavaScript function that remembers its previously passed values and returns the sum of the current and previous values.",
        a: "This function uses closures to remember previous values and returns the sum of the current and previous values each time it is called. It illustrates how closures can be used for state persistence in currying.",
        code: `
          const rememberedSum = () => {
            let previousSum = 0;
            return (value) => {
              previousSum += value;
              return previousSum;
            };
          };
    
          // Example usage:
          const sum = rememberedSum();
          console.log(sum(2)); // Output: 2
          console.log(sum(3)); // Output: 5
          console.log(sum(5)); // Output: 10
        `
      },
      {
        q: "Write a function where multiple calls of `add()` return the correct sum using the `valueOf()` method.",
        a: "This function demonstrates how currying can work with the `valueOf()` method. The `valueOf()` method is overridden to return the sum of arguments, making the object behave as a number in arithmetic expressions.",
        code: `
          const add = (a) => {
            let sum = a;
            const addMore = (b) => {
              sum += b;
              return addMore;
            };
            addMore.valueOf = () => sum;
            return addMore;
          };
    
          // Example usage:
          const result = add(2)(3)(5);
          console.log(result + 1); // Output: 11
        `
      },
      {
        q: "Write a function to chop string into chunks of given length and return it as an array.",
        a: "This problem involves chopping a string into smaller chunks of a specified length. There are two approaches to solve it: a brute-force method, where you manually slice the string, and a regex method. We'll focus on the brute-force approach here.",
        code: `
          const chop = (str, size = str.length) => {
            const arr = [];
            let i = 0;
            // Iterate through the string
            while (i < str.length) {
              // Slice the characters of given size
              // and push them into the output array
              arr.push(str.slice(i, i + size));
              i = i + size;
            }
            return arr;
          };
    
          // Example usage:
          console.log(chop('javascript', 3)); // Output: ['jav', 'asc', 'rip', 't']
        `
      },
      {
        q: "Write a function to chop string into chunks of given length and return it as an array.",
        a: "This problem involves chopping a string into smaller chunks of a specified length. There are two approaches to solve it: a brute-force method, where you manually slice the string, and a regex method. We'll focus on the brute-force approach here.",
        code: `
          const chop = (str, size = str.length) => {
            const arr = [];
            let i = 0;
            // Iterate through the string
            while (i < str.length) {
              // Slice the characters of given size
              // and push them into the output array
              arr.push(str.slice(i, i + size));
              i = i + size;
            }
            return arr;
          };
    
          // Example usage:
          console.log(chop('javascript', 3)); // Output: ['jav', 'asc', 'rip', 't']
        `
      },
      {
        q: "Write a function to merge two arrays.",
        a: "Merging two arrays involves combining their elements into one array.",
        code: `
          const mergeArrays = (arr1, arr2) => {
            return [...arr1, ...arr2];
          };
    
          // Example usage:
          console.log(mergeArrays([1, 2, 3], [4, 5, 6])); // Output: [1, 2, 3, 4, 5, 6]
        `
      },
      {
        q: "Write a function to chunk an array into smaller arrays of a given size.",
        a: "Chunking an array involves dividing it into multiple arrays of specified size.",
        code: `
          const chunkArray = (arr, size) => {
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
              result.push(arr.slice(i, i + size));
            }
            return result;
          };
    
          // Example usage:
          console.log(chunkArray([1, 2, 3, 4, 5, 6], 2)); // Output: [[1, 2], [3, 4], [5, 6]]
        `
      },
      {
        q: "Write a function to check if a string is a palindrome.",
        a: "A palindrome is a string that reads the same backward as forward.",
        code: `
          const isPalindrome = (str) => {
            const reversed = str.split('').reverse().join('');
            return str === reversed;
          };
    
          // Example usage:
          console.log(isPalindrome('racecar')); // Output: true
        `
      },
      {
        q: "Write a function to check if two strings are anagrams.",
        a: "An anagram is a word or phrase formed by rearranging the letters of another, using all original letters exactly once.",
        code: `
          const areAnagrams = (str1, str2) => {
            const sortedStr1 = str1.split('').sort().join('');
            const sortedStr2 = str2.split('').sort().join('');
            return sortedStr1 === sortedStr2;
          };
    
          // Example usage:
          console.log(areAnagrams('listen', 'silent')); // Output: true
        `
      },
      {
        q: "Write a function to reverse a number.",
        a: "Reversing a number involves reversing the order of its digits.",
        code: `
          const reverseNumber = (num) => {
            const reversed = num.toString().split('').reverse().join('');
            return parseInt(reversed) * Math.sign(num);
          };
    
          // Example usage:
          console.log(reverseNumber(12345)); // Output: 54321
        `
      },
      {
        q: "Write a function to merge two sorted arrays.",
        a: "Merging two sorted arrays involves combining their elements into a single sorted array.",
        code: `
          const mergeSortedArrays = (arr1, arr2) => {
            let i = 0, j = 0, result = [];
            while (i < arr1.length && j < arr2.length) {
              if (arr1[i] < arr2[j]) {
                result.push(arr1[i]);
                i++;
              } else {
                result.push(arr2[j]);
                j++;
              }
            }
            // Add remaining elements from either array
            return result.concat(arr1.slice(i)).concat(arr2.slice(j));
          };
    
          // Example usage:
          console.log(mergeSortedArrays([1, 3, 5], [2, 4, 6])); // Output: [1, 2, 3, 4, 5, 6]
        `
      },
      {
        q: "How to get the count of a character in a string in JavaScript?",
        a: "You can count occurrences of a character in a string by using the `split` method and subtracting 1 from the length of the resulting array.",
        code: `
          const name = "Jad Joubran";
          const countJ = name.split("J").length - 1;
          console.log(countJ); // Output: 2
        `
      },
      {
        q: "How to get a CSS property in JavaScript?",
        a: "You can get the CSS property of an element using the `getComputedStyle` method.",
        code: `
          const div = document.querySelector("#box");
          const padding = getComputedStyle(div).padding;
          console.log(padding); // Output: '15px' (or the computed padding value)
        `
      },
      {
        q: "How to skip values from array destructuring in JavaScript?",
        a: "You can skip values by using commas without variable names in the destructuring assignment.",
        code: `
          const [, , elevation] = [52.369661, 4.897243, 3];
          console.log(elevation); // Output: 3
        `
      },
      {
        q: "What is the difference between shallow copy and deep copy?",
        a: "A shallow copy copies the references of objects, not the objects themselves, while a deep copy duplicates everything, creating new objects that do not share references.",
        code: `
          // Shallow Copy Example
          const obj = { a: 1, b: { c: 2 } };
          const shallowCopy = Object.assign({}, obj);
          shallowCopy.b.c = 42;
          console.log(obj.b.c); // Output: 42 (shallow copy)
    
          // Deep Copy Example
          const deepCopy = JSON.parse(JSON.stringify(obj));
          deepCopy.b.c = 100;
          console.log(obj.b.c); // Output: 42 (deep copy)
        `
      },
      {
        q: "What is Redux and how to set it up?",
        a: "Redux is a predictable state management library for JavaScript applications. It helps you manage the state of your application in a single source of truth, called the store. Here's a basic setup:",
        code: `
          // Install Redux and React-Redux
          // npm install redux react-redux
    
          // Create actions
          const increment = () => ({ type: 'INCREMENT' });
          const decrement = () => ({ type: 'DECREMENT' });
    
          // Create a reducer
          const counter = (state = 0, action) => {
            switch (action.type) {
              case 'INCREMENT':
                return state + 1;
              case 'DECREMENT':
                return state - 1;
              default:
                return state;
            }
          };
    
          // Create a store
          import { createStore } from 'redux';
          const store = createStore(counter);
    
          // Use React-Redux to connect the store to your components
          import { Provider } from 'react-redux';
          import App from './App';
    
          ReactDOM.render(
            <Provider store={store}>
              <App />
            </Provider>,
            document.getElementById('root')
          );
        `
      },
      {
        q: "What is the Virtual DOM?",
        a: "The Virtual DOM is a lightweight copy of the real DOM. It allows React to update the DOM more efficiently by comparing the virtual DOM with a previous version and applying the differences (a process called reconciliation).",
        code: `
          // Example of React updating the Virtual DOM
          function App() {
            return <h1>Hello, world!</h1>;
          }
        `
      },
      {
        q: "What are React lifecycle methods?",
        a: "React lifecycle methods are special methods that are invoked at different stages of a component's lifecycle: mounting, updating, and unmounting.",
        code: `
          class MyComponent extends React.Component {
            componentDidMount() {
              // Called after the component is mounted
            }
    
            componentDidUpdate(prevProps, prevState) {
              // Called after the component updates
            }
    
            componentWillUnmount() {
              // Called before the component unmounts
            }
            
            render() {
              return <div>My Component</div>;
            }
          }
        `
      },
      {
        q: "What are React Hooks?",
        a: "React Hooks are functions that let you use state and other React features without writing a class. Common hooks include `useState`, `useEffect`, and `useContext`.",
        code: `
          import React, { useState } from 'react';
    
          function Counter() {
            const [count, setCount] = useState(0);
    
            return (
              <div>
                <p>You clicked {count} times</p>
                <button onClick={() => setCount(count + 1)}>
                  Click me
                </button>
              </div>
            );
          }
        `
      },
      {
        q: "What is CORS?",
        a: "CORS (Cross-Origin Resource Sharing) is a security feature that restricts how resources on a web page can be requested from another domain outside the domain from which the first resource was served.",
        code: `
          // Example of setting CORS headers in Express
          app.use((req, res, next) => {
            res.header('Access-Control-Allow-Origin', '*');
            res.header('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept');
            next();
          });
        `
      },
      {
        q: "What are CSS position properties?",
        a: "The `position` property in CSS specifies the positioning method for an element. The values include `static`, `relative`, `absolute`, `fixed`, and `sticky`.",
        code: `
          .example {
            position: absolute;
            top: 50px;
            left: 100px;
          }
        `
      },
      {
        q: "What is `flex-grow`, `flex-basis`, and how to create a responsive layout?",
        a: "`flex-grow` defines the ability for a flex item to grow. `flex-basis` specifies the initial size of a flex item. Use these properties to create a responsive layout.",
        code: `
          .container {
            display: flex;
          }
    
          .item {
            flex-grow: 1;
            flex-basis: 100px;
          }
        `
      },
      {
        q: "What are 5 ways to center a div?",
        a: "There are multiple ways to center a div in CSS. Some common methods are using `flexbox`, `grid`, `position`, `margin`, and `text-align`.",
        code: `
          /* Flexbox */
          .flexbox-center {
            display: flex;
            justify-content: center;
            align-items: center;
          }
    
          /* Grid */
          .grid-center {
            display: grid;
            place-items: center;
          }
    
          /* Position */
          .position-center {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
    
          /* Margin */
          .margin-center {
            margin: auto;
            width: 50%;
            height: 50%;
          }
    
          /* Text-align (for inline elements) */
          .text-align-center {
            text-align: center;
          }
        `
      },
      {
        q: "What are prototypes in JavaScript and provide examples?",
        a: "Prototypes in JavaScript are objects from which other objects inherit properties. Each function has a prototype property that is shared by all instances of the function's constructor.",
        code: `
          function Person(name) {
            this.name = name;
          }
    
          Person.prototype.greet = function() {
            console.log('Hello, ' + this.name);
          };
    
          const person1 = new Person('Alice');
          person1.greet(); // Output: Hello, Alice
        `
      },
      {
        q: "What is the event loop in JavaScript and provide examples?",
        a: "The event loop is a mechanism that allows JavaScript to perform non-blocking operations by offloading operations to the browser, which runs them in the background and pushes the result to the main thread once ready.",
        code: `
          console.log('Start');
    
          setTimeout(() => {
            console.log('Inside setTimeout');
          }, 0);
    
          console.log('End');
    
          // Output:
          // Start
          // End
          // Inside setTimeout
        `
      }
];